<template>
  <div class="article-list-wrapper">
    <div class="article-search">
      <form @submit.prevent="searchArticle" action="" class="search-box">
        <icon icon-class="search"></icon>
        <input type="search" ref="searchInput" placeholder="请搜索标题或内容" v-model="searchKey" name="" id="">
        <icon icon-class="close" class="clear" @click.native="clearSearch" v-show="searchKey"></icon>
      </form>
    </div>
    <div class="article-list" ref="expList" @scroll="scrollToLoad">
      <div class="article-item" v-for="item in articleList" :key="item.id" @click="toDetail(item)">
        <div class="article-card-content">
          <div class="article-top">
            <div class="article-title">{{item.title}} </div>
            <img class="article-thumb" :src="item.thumb" />
          </div>
          <div class="article-center" v-if="item.label.length>0">
            <div class="article-label" :style="styles[index]" v-for="(label, index) in item.label" :key="index">{{label.name}}</div>
          </div>
          <div class="article-bottom">
            <div class="article-tips">{{item.hits}}人已读</div>
            <!--
           <div class="article-tips-right">3天前</div>
           -->
          </div>
        </div>

      </div>
      <div class="data-loading" v-if="!isOver">
        <van-loading type="spinner" size="14px">加载中...</van-loading>
      </div>
      <div class="data-finish" v-if="isOver">无更多数据</div>
    </div>

  </div>
</template>
<style lang="less" scoped>
  .article-list-wrapper {
    min-height: 100vh;
    background: #FAFAFA;

    .list-loading {
      padding-top: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .article-search {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 50px;
      border-bottom: 1px solid #F2F0EC;
      padding: 10px 16px;
      background: #FFF;
      z-index: 10;

      .search-box {
        width: 100%;
        height: 36px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        background: #F7F7F7;
        border-radius: 3px;
        overflow: hidden;

        svg {
          font-size: 16px;
          color: #CCC;
          margin-left: 13px;

          &.clear {
            color: #999;
            margin-right: 8px;
            font-size: 14px;
          }
        }

        input {
          flex: 1;
          height: 100%;
          background: #F7F7F7;
          font-size: 14px;
          color: @black;
          padding: 0 8px;

          &[type=search]::-webkit-search-cancel-button {
            -webkit-appearance: none;
          }
        }
      }
    }

    .article-list {
      height: 100%;
      background: #FAFAFA;
      overflow-y: auto;
      -webkit-overflow-scroll: touch;
      padding: 0 16px 16px;
      padding-top: 50px;

      .article-item {
        margin-top: 12px;
        width: 100%;
        border-radius: 6px;
        overflow-y: hidden;
        box-shadow: 0px 2px 10px 0px rgba(51, 51, 51, 0.08);
        border: 1px solid transparent;
        background: #FFF;
        min-height: 100px;

        &.selected {
          border-color: @xile;
        }

        .article-card-content {
          margin-top: 5px;
          color: #666;

          .article-top {
            width: 96%;
            margin: 1px auto;
            padding: 5px 0px;
            display: block;
            position: relative;

            .article-title {
              font-size: 16px;
              font-weight: bold;
              line-height: 30px;
              margin-right: 75px;
              min-height: 60px;
              margin-left: 5px;
              ;
            }

            .article-thumb {
              position: absolute;
              right: 5px;
              top: 10px;
              width: 60px;
              height: 60px;
              display: block;
            }
          }

          .article-center {
            margin: 2px auto;
            width: 94%;
            min-height: 30px;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;

            .article-label {
              padding: 2px 13px;
              border-radius: 4px;
              font-size: 11px;
              height: 22px;
              line-height: 20px;
              text-align: center;
              margin: 0px 5px 5px 0px;
              display: block;
              color: #fff;
            }
          }

          .article-bottom {
            min-height: 30px;
            margin: 2px auto;
            width: 94%;
            position: relative;

            .article-tips {
              height: 20px;
              color: #aeaeae;
              font-size: 11px;
              margin-top: 3px;
              padding-left: 3px;
              line-height: 15px;
            }

            .article-tips-right {
              height: 20px;
              color: #aeaeae;
              font-size: 11px;
              margin-top: 3px;
              padding-left: 3px;
              line-height: 15px;
              position: absolute;
              right: 3px;
              top: 5px;
            }
          }
        }
      }
    }
  }
</style>
<script>
  import xDialog from '@/components/Common/dialog'
  export default {
    data() {
      return {
        doc_id: this.$route.query.doc_id,
        user_type: 0,
        dataDone: false,
        searchKey: '',
        articleList: [],
        page: 1,
        isOver: false,
        timer: null,
        styles: [
          'background-color:#6e8db0',
          'background-color:#6eb09d',
          'background-color:#b06e6e',
          'background-color:#aaaa7f',
          'background-color:#ff7d31',
          'background-color:#6e79b0',
          'background-color:#b06ea0'
        ]
      }
    },
    computed: {
      /*
      userInfo() {
        return this.$store.state.userInfo;
      }
      */
    },
    created() {
     
      this.getArticleList();
    },
    components: {
      xDialog
    },
    methods: {
      toDetail(item) {
        location.href="http://v2.xilezaixian.com/article?id=" + item.id
       /*
        this.$router.push({
          path: '/article-detail',
          query: {
            id: item.id
          },
          meta: {
            title: item.title
          }
        });
        */
      },
      getArticleList(type = 'normal', cb) {
        this.$root.post('/getArticleList', {
          doc_id: this.doc_id,
          count: 20,
          page: this.page,
          search: this.searchKey
        }).then(data => {
          this.dataDone = true;
          if (data && data.info.length <= 0 && type == 'search' && this.articleList.length > 0) {
            this.$notify('暂无搜索结果');
          }
          this.isOver = data.is_over == 1 ? true : false;
          if (data && data.info.length > 0) {
            if (type == 'search') {
              this.articleList = data.info;
            } else {
              this.articleList = [...this.articleList, ...data.info];
              // console.log(this.articleList)
            }
          }

          if (cb) cb();
        })
      },
      // 经方模板列表滚动加载
      scrollToLoad() {
        if (!this.isOver) {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            let pageHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight);
            let viewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight ||
              0;
            let scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop ||
              0;
            if (pageHeight - viewportHeight - scrollHeight < 20) {
              this.page++;
              this.getArticleList();
            }
          }, 200);
        }
      },
      searchArticle() {
        this.$toast.loading({
          duration: 0,
          loadingType: 'spinner',
          message: '搜索中...'
        })
        this.page = 1;
        this.getArticleList('search', () => {
          window.scrollTo(0, 0);
          this.$toast.clear();
          this.$refs.searchInput.blur();
        });
      },
      clearSearch() {
        this.searchKey = '';
        window.scrollTo(0, 0);
        this.page = 1;
        this.getArticleList('search');
      }


    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Public/articleList.vue